import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequestHeader } from "@tanstack/react-start/server";

/**
 * The host this render is for, on whichever side of the seam is asking.
 *
 * The server reads the request; the browser reads its own address. Resolving it
 * in a loader means the first painted frame is already the right face — a
 * landing page must never flash the room, nor the room the landing page.
 */
export const currentHost = createIsomorphicFn()
  .server(() => getRequestHeader("host") ?? "")
  .client(() => window.location.hostname);
